import { Component, inject } from '@angular/core'
import { LoadingBarModule } from '@ngx-loading-bar/core'
import { RouterOutlet } from '@angular/router'
import { AuthService } from './services/auth.service'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass'],
  imports: [LoadingBarModule, RouterOutlet],
})
export class AppComponent {
  authService = inject(AuthService)
  title = 'distributions'
}
